import React from 'react';
import { useAppSelector } from '../../../hooks/store-hooks';
import WorkspaceItemContext from '../../../contexts/workspace/workspace-item-context';
import { UdViewModel, UDViewType } from '../../../../udView/udview';
import { WorkspaceStateItem } from '../../../state/slices/workspace-slice';
import { EqualityFn } from 'react-redux';

export default function useView() {
    const view = useAppSelector((state) => state.workspace.items[state.workspace.selectedId].view);
    const id = useAppSelector((state) => state.workspace.selectedId);
    return { id, view };
}

export function useFocusedWorkspaceSelector<T>(subSelector: (workspace: WorkspaceStateItem) => T) {
    return useAppSelector((state) => subSelector(state.workspace.items[state.workspace.selectedId]));
}

export function useWorkspaceView<T>(subSelector: (view: UdViewModel) => T) {
    const context = React.useContext(WorkspaceItemContext);
    return useAppSelector((state) => subSelector(state.workspace.items[context.id].view));
}

export function useWorkspace<T>(subSelector: (view: WorkspaceStateItem) => T, e?: EqualityFn<T>) {
    const context = React.useContext(WorkspaceItemContext);
    return useAppSelector((state) => subSelector(state.workspace.items[context.id]), e);
}

export function useCanSaveView() {
    const canEditCompanyViews = useAppSelector((x) => x.user.rights.canEditCompanyViews);
    const companyFeaturesEnabled = useAppSelector((x) => x.user.rights.companyFeaturesEnabled);
    const viewEdited = useFocusedWorkspaceSelector((x) => x.viewModified);
    const selectedViewType = useFocusedWorkspaceSelector((x) => x.view.type);
    const defaultViewSelected = useFocusedWorkspaceSelector((x) => !x.view.id);

    const canSaveView =
        !defaultViewSelected && viewEdited && (selectedViewType === UDViewType.user || (companyFeaturesEnabled && canEditCompanyViews));

    return canSaveView;
}
